import { PipeTransform, Pipe } from '@angular/core';
import { Item } from '../_interface/item';

@Pipe({
    name: 'projFilter'
})
export class ProjFilterPipe implements PipeTransform {
    transform(projects: Item[], searchTerm: string): Item[] {
        if( !projects || !searchTerm ) {
            return projects;
        }

        return projects.filter( projects => 
            projects.title.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) !== -1);
    }
}